import _ from "lodash";

export const query_params = (params) =>
  Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
export const PostData = (params) => {
  let formData = new FormData();
  _.forEach(params, (v, k) => {
    formData.append(k, v);
  });
  return formData;
};
